export const hostelRoomsData = [
    {
      key: "1",
      id: "HR819382",
      roomNo: "A1",
      hostelName: "Phoenix Residence",
      roomType: "One Bed",
      noofBed: "1",
      amount: "RM200",
    },
    {
      key: "2",
      id: "HR819381",
      roomNo: "A2",
      hostelName: "Tranquil Haven",
      roomType: "One Bed AC",
      noofBed: "1",
      amount: "RM300",
    },
    {
      key: "3",
      id: "HR819380",
      roomNo: "A3",
      hostelName: "Radiant Towers",
      roomType: "Two Bed",
      noofBed: "2",
      amount: "RM400",
    },
    {
      key: "4",
      id: "HR819379",
      roomNo: "A4",
      hostelName: "Nova Nest",
      roomType: "One Bed",
      noofBed: "1",
      amount: "RM200",
    },
    {
      key: "5",
      id: "HR819378",
      roomNo: "B1",
      hostelName: "Vista Villa",
      roomType: "One Bed AC",
      noofBed: "1",
      amount: "RM300",
    },
    {
      key: "6",
      id: "HR819377",
      roomNo: "B2",
      hostelName: "Zenith Zone",
      roomType: "Two Bed",
      noofBed: "2",
      amount: "RM400",
    },
    {
      key: "7",
      id: "HR819376",
      roomNo: "B3",
      hostelName: "Summit Springs",
      roomType: "One Bed",
      noofBed: "1",
      amount: "RM200e",
    },
    {
      key: "8",
      id: "HR819375",
      roomNo: "B4",
      hostelName: "Beacon Breeze",
      roomType: "Two Bed AC",
      noofBed: "2",
      amount: "RM600",
    },
    {
      key: "9",
      id: "HR819374",
      roomNo: "C1",
      hostelName: "Empyrean Estate",
      roomType: "One Bed",
      noofBed: "1",
      amount: "RM200",
    },
    {
      key: "10",
      id: "HR819373",
      roomNo: "C2",
      hostelName: "Nexus Nook",
      roomType: "Two Bed AC",
      noofBed: "2",
      amount: "RM600",
    },
  ];